/* Curly Bliss storefront behaviour */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) { return 'Rs ' + Math.round(cents / 100).toLocaleString('en-LK'); };

  /* announcement bar: cross-fade */
  document.querySelectorAll('.k-ann').forEach(function (bar) {
    var items = bar.querySelectorAll('[data-ann-item]'); if (items.length < 2) return;
    var i = 0, timer;
    var show = function (n) {
      var old = items[i]; i = (n + items.length) % items.length; if (old === items[i]) return;
      old.classList.remove('is-on'); old.classList.add('is-out');
      setTimeout(function () { old.classList.remove('is-out'); }, 650);
      items[i].classList.add('is-on');
    };
    var auto = function () { clearInterval(timer); if (!reduce) timer = setInterval(function () { show(i + 1); }, 5000); };
    var next = bar.querySelector('[data-ann-next]'), prev = bar.querySelector('[data-ann-prev]');
    next && next.addEventListener('click', function () { show(i + 1); auto(); });
    prev && prev.addEventListener('click', function () { show(i - 1); auto(); });
    bar.addEventListener('mouseenter', function () { clearInterval(timer); });
    bar.addEventListener('mouseleave', auto);
    auto();
  });

  var EASE = 'cubic-bezier(.22,.61,.36,1)';
  var motion = document.documentElement.classList.contains('cb-motion');

  /* draw a curl strand */
  var draw = function (path, dur) {
    if (!motion || !path || !path.getTotalLength) return;
    var L = path.getTotalLength(); path.style.strokeDasharray = L;
    path.animate([{ strokeDashoffset: L }, { strokeDashoffset: 0 }], { duration: dur || 900, easing: EASE });
  };
  document.querySelectorAll('.k-pat').forEach(function (b) {
    b.addEventListener('mouseenter', function () { draw(b.querySelector('path'), 800); });
  });

  /* scroll reveal + highlight paint */
  if (motion && 'IntersectionObserver' in window) {
    var sel = '.cb .k-head, .cb .k-picker, .cb .k-card, .cb .k-step, .cb .k-coll, .cb .k-btabs, .cb .k-bpanel, .cb .k-why, .cb .k-news-wrap, .cb .k-chead, .cb .k-filters, .cb-claims';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in'); io.unobserve(e.target);
        e.target.querySelectorAll('.k-swipe').forEach(function (w) { w.classList.add('is-painted'); });
        if (e.target.classList.contains('k-why')) e.target.querySelectorAll('.k-strands path').forEach(function (p, k) { setTimeout(function () { draw(p, 1400); }, k * 90); });
        if (e.target.classList.contains('k-picker')) e.target.querySelectorAll('.k-pat path').forEach(function (p, k) { setTimeout(function () { draw(p, 1000); }, k * 70); });
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.closest('.k-hero')) return;
      var sibs = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      if (el.classList.contains('k-card') || el.classList.contains('k-step') || el.classList.contains('k-coll')) {
        var cell = el.closest('.cb-cell') || el, list = Array.prototype.slice.call(cell.parentElement.children).filter(function (c) { return !c.hidden; });
        el.style.setProperty('--cb-d', ((list.indexOf(cell) % 4) * 0.08) + 's');
      }
      el.classList.add('cb-reveal'); io.observe(el);
    });
    /* hero highlight paints after the headline rises */
    setTimeout(function () { document.querySelectorAll('.k-hero .k-swipe').forEach(function (w) { w.classList.add('is-painted'); }); }, 350);
  } else {
    document.querySelectorAll('.k-swipe').forEach(function (w) { w.classList.add('is-painted'); });
  }

  /* dropdowns close on outside click (mobile drawer) */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.cb-drawer[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* homepage curl-pattern picker filters the product grid */
  var grid = document.querySelector('[data-cb-grid]');
  document.querySelectorAll('#home-picker .k-pat').forEach(function (b) {
    b.addEventListener('click', function () {
      var t = b.dataset.t, fam = t[0] === '2' ? 'wavy' : t[0] === '3' ? 'curly' : 'coily';
      document.querySelectorAll('#home-picker .k-pat').forEach(function (o) { o.setAttribute('aria-pressed', o === b); });
      var lab = document.querySelector('[data-pick-label]'); if (lab) lab.textContent = 'Showing picks for ' + t;
      var k = document.querySelector('[data-grid-kicker]'); if (k) k.textContent = 'Picked for ' + t + ' hair';
      var h = document.querySelector('[data-grid-title]'); if (h) h.innerHTML = 'Your <span class="k-swipe">' + fam + '</span> shortlist';
      if (!grid) return;
      var letter = t[1];
      var LIGHT = ['fine hair', 'weightless collection', 'volume', 'gels', 'clarifying', 'oily scalp', 'heat protection'];
      var RICH = ['moisture', 'creams', 'protein-free', '4c', 'leave-ins', 'deep conditioners & masks', 'co-wash', 'kids'];
      var limit = +grid.dataset.limit || 8;
      var cells = Array.prototype.slice.call(grid.querySelectorAll('.cb-cell'));
      var scored = cells.map(function (cell, idx) {
        var card = cell.querySelector('.k-card'); if (!card) return { cell: cell, s: -1, idx: idx };
        var fams = (card.dataset.fams || '').split(' ').filter(Boolean), tags = (card.dataset.tags || '').split('|');
        if (card.classList.contains('k-sold') || fams.indexOf(fam) < 0) return { cell: cell, s: -1, idx: idx };
        var sc = 10 + (fams.length === 1 ? 6 : fams.length === 2 ? 3 : 0);
        var hit = function (list) { return tags.filter(function (x) { return list.indexOf(x) > -1; }).length; };
        if (letter === 'A') sc += 2 * hit(LIGHT) - hit(RICH);
        if (letter === 'C') sc += 2 * hit(RICH) - hit(LIGHT);
        if (letter === 'B') sc += hit(LIGHT) + hit(RICH) > 0 ? 1 : 0;
        return { cell: cell, s: sc, idx: idx };
      });
      scored.sort(function (a, b) { return b.s - a.s || a.idx - b.idx; });
      draw(b.querySelector('path'), 900);
      var apply = function () {
        var shown = 0, fresh = [];
        scored.forEach(function (o) { grid.appendChild(o.cell); var ok = o.s >= 0 && shown < limit; o.cell.hidden = !ok; if (ok) { shown++; fresh.push(o.cell.querySelector('.k-card')); } });
        if (motion) fresh.forEach(function (c, k) { c.classList.add('is-in'); c.animate([{ opacity: 0, transform: 'translateY(16px) scale(.98)' }, { opacity: 1, transform: 'none' }], { duration: 520, delay: k * 60, easing: EASE, fill: 'backwards' }); });
      };
      var current = Array.prototype.slice.call(grid.querySelectorAll('.cb-cell:not([hidden]) .k-card'));
      if (motion && current.length) {
        var anims = current.map(function (c) { return c.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(8px) scale(.98)' }], { duration: 220, easing: 'ease-in', fill: 'forwards' }); });
        setTimeout(function () { anims.forEach(function (a) { a.cancel(); }); apply(); }, 230);
      } else apply();
      var note = document.querySelector('[data-pick-note]');
      if (note) note.textContent = 'Sorted for ' + t + ': products made only for ' + fam + ' hair come first, then ' + (letter === 'A' ? 'lighter formulas for looser ' : letter === 'C' ? 'richer, more moisturising formulas for tighter ' : 'all-rounders for ') + fam + ' hair.';
      var gt = grid.getBoundingClientRect().top; if (gt > innerHeight * 0.6 || gt < 0) window.scrollTo({ top: scrollY + gt - 140, behavior: reduce ? 'auto' : 'smooth' });
    });
  });

  /* quick add from cards */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cb-add]'); if (!btn) return;
    e.preventDefault(); btn.disabled = true; btn.textContent = '…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +btn.dataset.cbAdd, quantity: 1 }] }) })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) { document.querySelectorAll('[data-cb-count]').forEach(function (c) { c.textContent = cart.item_count; c.classList.remove('is-pop'); void c.offsetWidth; c.classList.add('is-pop'); }); btn.textContent = '✓'; setTimeout(function () { btn.textContent = '+'; btn.disabled = false; }, 1400); })
      .catch(function () { btn.textContent = '+'; btn.disabled = false; });
  });

  /* brand tabs */
  document.querySelectorAll('[data-cb-brands]').forEach(function (root) {
    var tabs = root.querySelectorAll('.k-btab'), panels = root.querySelectorAll('[data-panel]');
    tabs.forEach(function (t) { t.addEventListener('click', function () {
      tabs.forEach(function (o) { o.setAttribute('aria-selected', o === t); });
      panels.forEach(function (p) { var on = p.dataset.panel === t.dataset.i; if (on && p.hidden) { p.classList.remove('is-entering'); void p.offsetWidth; p.classList.add('is-entering'); p.classList.add('is-in'); } p.hidden = !on; });
    }); });
  });

  /* collection sort */
  var sort = document.querySelector('[data-cb-sort]');
  sort && sort.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString(); });

  /* product page */
  var pdp = document.querySelector('[data-cb-product]');
  if (pdp) {
    var main = pdp.querySelector('[data-cb-main] img');
    var setMain = function (src) { if (!main || !src) return; main.classList.add('is-swapping'); setTimeout(function () { main.removeAttribute('srcset'); main.src = src; var done = function () { main.classList.remove('is-swapping'); }; if (main.complete) setTimeout(done, 30); else main.onload = done; }, motion ? 180 : 0); };
    pdp.querySelectorAll('[data-cb-thumb]').forEach(function (b) { b.addEventListener('click', function () {
      setMain(b.dataset.cbThumb); pdp.querySelectorAll('[data-cb-thumb]').forEach(function (o) { o.setAttribute('aria-pressed', o === b); });
    }); });
    var q = pdp.querySelector('[data-cb-q]');
    pdp.querySelector('[data-cb-plus]') && pdp.querySelector('[data-cb-plus]').addEventListener('click', function () { q.value = Math.min(9, +q.value + 1); });
    pdp.querySelector('[data-cb-minus]') && pdp.querySelector('[data-cb-minus]').addEventListener('click', function () { q.value = Math.max(1, +q.value - 1); });
    var vj = document.querySelector('[data-cb-variants]'), variants = vj ? JSON.parse(vj.textContent) : [];
    var opts = pdp.querySelectorAll('[data-cb-opt]');
    var update = function () {
      var sel = []; opts.forEach(function (o) { if (o.checked) sel[+o.dataset.cbOpt] = o.value; });
      pdp.querySelectorAll('.cb-opts').forEach(function (fs, i) { var l = fs.querySelector('[data-cb-optlabel]'); if (l) l.textContent = sel[i]; });
      var v = variants.find(function (x) { return x.options.every(function (val, i) { return val === sel[i]; }); }); if (!v) return;
      pdp.querySelector('[data-cb-id]').value = v.id;
      pdp.querySelector('[data-cb-price]').textContent = money(v.price);
      var btn = pdp.querySelector('[data-cb-addbtn]'); btn.disabled = !v.available; btn.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (v.featured_media && v.featured_media.preview_image) setMain(v.featured_media.preview_image.src + (v.featured_media.preview_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1400');
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
    };
    opts.forEach(function (o) { o.addEventListener('change', update); });
    /* mark sold-out option values */
    opts.forEach(function (o) {
      if (opts.length && pdp.querySelectorAll('.cb-opts').length === 1) {
        var v = variants.find(function (x) { return x.options[0] === o.value; });
        if (v && !v.available) o.closest('label').classList.add('k-is-soldout');
      }
    });
  }
})();

/* Curly Bliss cart page: qty / remove without reload, order note autosave */
(function () {
  var root = document.querySelector('[data-cb-cart]'); if (!root) return;
  var id = root.dataset.section, busy = false;
  var money = function (c) { return 'Rs ' + Math.round(c / 100).toLocaleString('en-LK'); };
  function paint(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cb-cart]'); if (!fresh) return location.reload();
    root.classList.add('is-refresh');
    root.innerHTML = fresh.innerHTML;
    root.querySelectorAll('.k-swipe').forEach(function (w) { w.classList.add('is-painted'); });
  }
  function change(line, qty) {
    if (busy) return; busy = true;
    var li = root.querySelector('.cb-line[data-key="' + line + '"]');
    if (li) li.classList.add(qty === 0 ? 'is-leaving' : 'is-busy');
    var wait = qty === 0 ? new Promise(function (r) { setTimeout(r, 380); }) : Promise.resolve();
    var req = fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: line, quantity: qty, sections: [id], sections_url: location.pathname }) })
      .then(function (r) { return r.json(); });
    Promise.all([req, wait]).then(function (res) {
      var cart = res[0];
      if (cart.status && cart.status >= 400) throw cart;
      if (cart.sections && cart.sections[id]) paint(cart.sections[id]); else location.reload();
      document.querySelectorAll('[data-cb-count]').forEach(function (c) { c.textContent = cart.item_count; c.classList.remove('cb-bump'); void c.offsetWidth; c.classList.add('cb-bump'); });
      var nl = root.querySelector('.cb-line[data-key="' + line + '"] .cb-line__price b'); if (nl) { nl.classList.add('cb-bump'); }
    }).catch(function (err) {
      if (li) li.classList.remove('is-busy', 'is-leaving');
      var msg = (err && (err.description || err.message)) || 'Could not update your bag. Please try again.';
      if (li) { var p = li.querySelector('.cb-line__err') || li.querySelector('.cb-line__info').appendChild(document.createElement('span')); p.className = 'cb-line__err cb-line__disc'; p.textContent = msg; }
    }).then(function () { busy = false; });
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cb-qty]'); if (!b || b.disabled) return;
    e.preventDefault();
    change(b.closest('.cb-line').dataset.key, Math.max(0, +b.dataset.cbQty));
  });
  var t;
  root.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cb-note]')) return;
    clearTimeout(t); var v = e.target.value;
    t = setTimeout(function () { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) }); }, 500);
  });
})();

/* Curly Bliss mobile: off-canvas menu, filter toggle, sticky add-to-bag */
(function () {
  var nav = document.querySelector('[data-cb-mnav]');
  var openBtn = document.querySelector('[data-cb-menu-open]');
  if (nav && openBtn) {
    document.body.appendChild(nav);
    var last, timer;
    var open = function () {
      clearTimeout(timer); last = document.activeElement;
      nav.hidden = false; void nav.offsetWidth; nav.classList.add('is-open');
      document.documentElement.classList.add('cb-lock');
      openBtn.setAttribute('aria-expanded', 'true');
      var x = nav.querySelector('.cb-mnav__x'); x && setTimeout(function () { x.focus(); }, 60);
    };
    var close = function () {
      nav.classList.remove('is-open');
      document.documentElement.classList.remove('cb-lock');
      openBtn.setAttribute('aria-expanded', 'false');
      timer = setTimeout(function () { nav.hidden = true; }, 480);
      last && last.focus && last.focus();
    };
    openBtn.addEventListener('click', open);
    nav.addEventListener('click', function (e) {
      if (e.target.closest('[data-cb-menu-close]')) return close();
      var a = e.target.closest('a[href]'); if (a) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !nav.hidden) close(); });
    window.addEventListener('resize', function () { if (window.innerWidth > 980 && !nav.hidden) close(); });
    /* one group open at a time */
    nav.querySelectorAll('.cb-mnav__grp').forEach(function (d) {
      d.addEventListener('toggle', function () { if (d.open) nav.querySelectorAll('.cb-mnav__grp[open]').forEach(function (o) { if (o !== d) o.open = false; }); });
    });
  }

  /* keep the active curl pattern in view in scrolling pickers */
  document.querySelectorAll('.k-pats').forEach(function (row) {
    var on = row.querySelector('[aria-pressed="true"]');
    if (on && row.scrollWidth > row.clientWidth) row.scrollLeft = on.offsetLeft - row.clientWidth / 2 + on.offsetWidth / 2;
  });

  /* swipe the main product image */
  var main = document.querySelector('[data-cb-main]');
  if (main) {
    var sx = null;
    main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) < 40) return;
      var th = Array.prototype.slice.call(document.querySelectorAll('[data-cb-thumb]')); if (!th.length) return;
      var i = th.findIndex(function (b) { return b.getAttribute('aria-pressed') === 'true'; });
      var n = th[(i + (dx < 0 ? 1 : -1) + th.length) % th.length]; n.click();
      n.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }, { passive: true });
  }

  var ft = document.querySelector('[data-cb-ftoggle]'), fl = document.getElementById('cb-filters');
  if (ft && fl) ft.addEventListener('click', function () {
    var on = fl.classList.toggle('is-open'); ft.setAttribute('aria-expanded', on);
  });

  var add = document.querySelector('[data-cb-addbtn]'), pdp = document.querySelector('[data-cb-product]');
  if (add && pdp) {
    var title = (pdp.querySelector('h1') || {}).textContent || '';
    var bar = document.createElement('div');
    bar.className = 'cb-stickybuy'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="cb-stickybuy__t"><b></b><span></span></div><button type="button" tabindex="-1"></button>';
    bar.querySelector('b').textContent = title.trim();
    var price = pdp.querySelector('[data-cb-price]'), btn = bar.querySelector('button');
    var sync = function () {
      bar.querySelector('span').textContent = price ? price.firstChild.textContent.trim() : '';
      btn.textContent = add.textContent.trim(); btn.disabled = add.disabled;
    };
    sync(); document.body.appendChild(bar);
    new MutationObserver(sync).observe(pdp, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    btn.addEventListener('click', function () { add.click(); });
    var check = function () { var r = add.getBoundingClientRect(); bar.classList.toggle('is-on', r.bottom < 0); };
    window.addEventListener('scroll', check, { passive: true }); check();
  }
})();


/* predictive search (header, mobile menu, search page) */
(function () {
  var money = function (c) { return 'Rs ' + Math.round(c / 100).toLocaleString('en-LK'); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  document.querySelectorAll('[data-cb-predict]').forEach(function (input) {
    var form = input.closest('form'); if (!form) return;
    var box = document.createElement('div'); box.className = 'cb-predict'; box.hidden = true; box.setAttribute('role', 'listbox');
    form.appendChild(box);
    var t, ctrl, idx = -1;
    var items = function () { return Array.prototype.slice.call(box.querySelectorAll('a')); };
    var hide = function () { box.hidden = true; idx = -1; };
    var run = function () {
      var v = input.value.trim(); if (v.length < 2) return hide();
      if (ctrl) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
      fetch('/search/suggest.json?q=' + encodeURIComponent(v) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor,tag', ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          var all = '/search?q=' + encodeURIComponent(v) + '&options%5Bprefix%5D=last';
          box.innerHTML = ps.length ? ps.map(function (p) {
            return '<a href="' + esc(p.url) + '" role="option">' + (p.image ? '<img src="' + esc(p.image) + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '') +
              '<span><b>' + esc(p.title) + '</b><small>' + esc(p.vendor || '') + ' · ' + money(Math.round(parseFloat(p.price) * 100)) + '</small></span></a>';
          }).join('') + '<a class="cb-predict__all" href="' + all + '">See all results for “' + esc(v) + '”</a>'
            : '<div class="cb-predict__none">No products match “' + esc(v) + '”. Press Enter to search everything.</div>';
          idx = -1; box.hidden = false;
        }).catch(function () {});
    };
    input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(run, 180); });
    input.addEventListener('focus', function () { if (input.value.trim().length > 1 && box.innerHTML) box.hidden = false; });
    input.addEventListener('keydown', function (e) {
      var a = items(); if (box.hidden || !a.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault(); idx = (idx + (e.key === 'ArrowDown' ? 1 : -1) + a.length) % a.length;
        a.forEach(function (el, i) { el.setAttribute('aria-selected', i === idx); });
      } else if (e.key === 'Enter' && idx > -1) { e.preventDefault(); location.href = a[idx].href; }
      else if (e.key === 'Escape') hide();
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
  });
})();

/* Curly Bliss product info: tabs on desktop, accordion on mobile */
(function () {
  var root = document.querySelector('[data-cb-info]'); if (!root) return;
  var tabs = root.querySelectorAll('[data-cb-tab]'), panels = root.querySelectorAll('[data-cb-panel]');
  var show = function (key) {
    tabs.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.cbTab === key); t.tabIndex = t.dataset.cbTab === key ? 0 : -1; });
    panels.forEach(function (p) { p.hidden = p.dataset.cbPanel !== key; });
  };
  if (tabs.length) show(tabs[0].dataset.cbTab);
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { show(t.dataset.cbTab); });
    t.addEventListener('keydown', function (e) {
      var d = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 0; if (!d) return;
      e.preventDefault(); var n = tabs[(i + d + tabs.length) % tabs.length]; n.focus(); show(n.dataset.cbTab);
    });
  });
  root.querySelectorAll('[data-cb-acc]').forEach(function (b) {
    b.addEventListener('click', function () { b.setAttribute('aria-expanded', b.getAttribute('aria-expanded') !== 'true'); });
  });
})();
